import { Navigate, RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

import PayoutsScreen from './payouts/PayoutsScreen';

export const invoiceRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="invoices" />,
  },
  {
    path: 'invoices',
    lazy: () =>
      import('./invoices/InvoiceScreen').then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: 'settings',
    lazy: () =>
      import('./settings/BillingSettingsScreen').then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: 'payouts',
    Component: PayoutsScreen,
  },
  {
    path: 'payment-links',
    lazy: () =>
      import('./payment-links/PaymentLinksScreen').then((m) => ({
        Component: m.PaymentLinksScreen,
      })),
  },
  {
    path: 'payments',
    lazy: () =>
      import('./payments/PaymentsScreen').then((m) => ({
        Component: m.default,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/billing/invoices"
        linkText="Go back to invoices"
      />
    ),
  },
];
